import { EstimateEnergyContent } from './EstimateEnergyMap'

export { default } from './EstimateEnergy'

export const EstimateEnergyMapConfig = {
  // Controller: EstimateMapController,
  Content: EstimateEnergyContent,
}
